<app-manage-template [title]="'Manage Members'"  [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'INCLUDED_CONVERSATIONS'"
(updateParent)="updateBusinessNetwork($event)" [dropdownContext]="filterData" [holder]="'Search by UID, name, email or organization'"
(updateMembers)="updateContactMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll">

<div class="row mt-1">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
</div>


</app-manage-template>
